export default "__VITE_PUBLIC_ASSET__d7651b25__"